// @flow
import * as React from 'react';
import type { RouterHistory } from 'react-router-dom';
import type { Authentication, VerificationResult, UserData } from '../../types';
import BusyIndicator from '../Common/BusyIndicator';
import VerifyLoginDisplay from './VerifyLoginDisplay';
import verifyCode from '../../utils/actions/verifyCode';
import grantAccess from '../../utils/actions/grantAccess';
import withAuthentication from '../withAuthentication';

type Props = {
  history: RouterHistory,
  authentication: Authentication
};

const VerifyLoginPage = (props: Props) => {
  const [code, setCode] = React.useState<string>('');
  const [verified, setVerified] = React.useState<boolean>(false);
  const [errors, setErrors] = React.useState<Array<string>>([]);
  const [aborting, setAborting] = React.useState<boolean>(false);

  if (
    !props.authentication.verificationToken ||
    !props.authentication.verificationType
  ) {
    props.history.replace('/login');
  }

  const handleSubmit = (event: SyntheticEvent<HTMLButtonElement>) => {
    event.preventDefault();

    if (code.length !== 6) {
      setErrors(['Invalid code, please try again']);
      setCode('');
      return;
    }

    setErrors([]);

    verifyCode(props.authentication.verificationToken, code)
      .then((result: VerificationResult) => {
        if (result.failureAction) {
          // verification failed
          setCode('');
          setErrors([result.failureMessage]);

          if (result.failureAction === 2) {
            // abort
            setAborting(true);
          }
        } else {
          // verification succeeded
          setVerified(true);

          grantAccess(result.token)
            .then((userData: UserData) => {
              props.authentication.setUserData(userData);
              window.location.href = window.location.origin;
            })
            .catch(setErrors);
        }
      })
      .catch(error => {
        setErrors(['An unexpected error has occurred.']);
        setAborting(true);
      });
  };

  const handleCancel = () => {
    window.location.href = window.location.origin;
  };

  return (
    <>
      {verified ? (
        <BusyIndicator size="5x" text="Logging in" />
      ) : (
        <VerifyLoginDisplay
          code={code}
          verificationType={props.authentication.verificationType}
          verificationDetails={props.authentication.verificationDetails}
          errors={errors}
          aborting={aborting}
          onChange={event => setCode(event.currentTarget.value)}
          onCancel={handleCancel}
          onSubmit={handleSubmit}
        />
      )}
    </>
  );
};

export default withAuthentication(VerifyLoginPage);
